module.exports = __webpack_public_path__ + "media/podcast-trailer.8eaf7fb7.mp4";